import { FolderOpen, ChevronDown } from "lucide-react";

export default function FolderSelector({

    value,

    onChange,

    folders = []

}){

    return(

        <div className="folder-selector">

            <label>

                Upload Folder

            </label>

            <div className="folder-select">

                <FolderOpen
                    size={18}
                    className="folder-icon"
                />

                <select

                    value={value}

                    onChange={e=>

                        onChange?.(
                            e.target.value
                        )

                    }

                >

                    {

                        folders.map(folder=>

                            <option

                                key={folder.value}

                                value={folder.value}

                            >

                                {folder.label}

                            </option>

                        )

                    }

                </select>

                <ChevronDown
                    size={18}
                    className="folder-arrow"
                />

            </div>
<style>{`.folder-selector{

    margin-top:24px;

}

.folder-selector label{

    display:block;

    margin-bottom:10px;

    font-size:14px;

    font-weight:600;

    color:#334155;

}

.folder-select{

    position:relative;

    display:flex;

    align-items:center;

    border:1px solid #D1D5DB;

    border-radius:14px;

    background:#FFF;

    transition:.18s;

}

.folder-select:hover{

    border-color:#94A3B8;

}

.folder-select:focus-within{

    border-color:#2563EB;

    box-shadow:
        0 0 0 4px rgba(37,99,235,.08);

}

.folder-icon{

    margin-left:14px;

    color:#64748B;

    flex-shrink:0;

}

.folder-select select{

    flex:1;

    height:48px;

    border:none;

    outline:none;

    background:transparent;

    padding:0 14px;

    font-size:14px;

    appearance:none;

    cursor:pointer;

}

.folder-arrow{

    margin-right:14px;

    color:#94A3B8;

    pointer-events:none;

}`}</style>
        </div>

    );

}